module.exports = __webpack_public_path__ + "img/medictum.a3998e92.svg";